import client from './client';

export const listAlarms = () => client.get('/v1/user/alarms/');
